<template>
    <div>
        <div  >
            <van-divider>单位信息</van-divider>
            <van-cell-group>
                <van-cell title="赛季" :value="pageData.sjname" />
                <van-cell title="赛区" :value="pageData.sqname" />
                <van-cell title="单位" :value="pageData.danwei" />
                <van-cell title="队伍名称" :value="pageData.mingcheng" />
            </van-cell-group>
            <van-divider>用餐信息</van-divider>
            <div style="padding: 20px; line-height: 28px; font-size: 14px;">
                <p v-if="pageData.dinnerdata.length>0 && pageData.dinner" v-for="p in pageData.dinnerdata">{{p}}</p>
                <p v-else >暂未配置,如有疑问请联系管理员</p>
            </div>

        </div>


        <div style="padding: 20px;">
            <van-button size="large" plain style="margin: 10px 0" @click.stop="edit">信息需要修改</van-button>
            <van-button size="large" plain style="margin: 10px 0" @click.stop="goIndex">返回首页</van-button>
        </div>


    </div>
</template>

<style scoped="">
</style>
<script>
    import {
            Cell, CellGroup,Field,RadioGroup,Radio,DatetimePicker,Picker,NoticeBar,Button,Dialog,Stepper
    } from 'vant';
    export default {
        name: 'saiConfirmDetailDinner',
        components: {
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Field.name]: Field,
            [DatetimePicker.name]: DatetimePicker,
            [Picker.name]: Picker,
            [NoticeBar.name]: NoticeBar,
            [Button.name]: Button,
            [Dialog.name]: Dialog,
            [Stepper.name]: Stepper,
        },
        data: function () {
            return {
                pageData:{
                    'id' : this.$route.query.id,
                    'dinnerdata' :[],
                    'dinner' :'',
                    'face' :'',
                    'phone' :'',
                },
                formData:{
                    'id' : this.$route.query.id,
                },
            }
        },
        mounted: function () {
            let that = this;
            document.title = "用餐信息";
            this.$api.get('/api/sai/dinnerdetail', {
                'id':that.pageData.id
            }, r => {
                this.pageData = r.data;
            });

        },
        filters:{
          date:function (value) {
              return (new Date(value*1000).Format("yyyy-MM-dd hh:mm"));
          }
        },
        methods: {
            goIndex:function () {
                this.$router.push({
                    'name' :'saiConfirmManage',
                    'query':{}
                })
            },
            edit:function () {
                let that = this;
                this.$router.push({
                    'name' :'saiConfirmQr2',
                    'query':{'id':that.pageData.id}
                })
            },
        }
    }
</script>


// WEBPACK FOOTER //
// SaiConfirmDetailDinner.vue?5c2f3d56